import { defineAction } from '~/prix'
import healthTeamSmartMappingAction from './healthTeamSmartMapping.action.json' with { type: 'json' }
import { featureCollection, latitude, longitude, multiPolygon, polygon } from '~/prix/types/presets/geo'
import { SmartMappingOptions } from '~/packages/geo/applySmartMapping/smartMapping.typing'
import { z } from 'zod'

export const recommendedSmartMappingOptions: SmartMappingOptions = {
  useCustomDelimitationPolygon: false,
  preserveClassificationsQuantile: 0,
  maxGdfClassifications: 800,
  minOccurrencesPerClassification: 'auto',
  generalOutliersQuantile: 0,
  classificationOutliersQuantile: 0.1,
  minAreaKm2: 0.01,
  simplifyEpsilon: 0.0005,
  withTopology: true,
}

const polygonOrMultiPolygon = z.union([polygon(), multiPolygon()])
const coverageAreaKind = z.enum([
  'smartMapping',
  'deprecated',
  'manualDrawing',
  'authorityProvided',
  'openStreetMapSourced',
])

const healthTeamSmartMappingDefinition = defineAction({
  ...healthTeamSmartMappingAction,

  input: z.object({
    delimitationPolygon: polygonOrMultiPolygon,
    delimitationId: z.number(),
    delimitationType: z.enum(['municipality']),
    delimitationKey: z.string().nullish(),
    useCustomDelimitationPolygon: z.boolean().default(false),
    respectCentralPoint: z.boolean().default(false),
    usePointsDelimitationPolygon: z.boolean().default(true),
    preserveClassificationsQuantile: z.number().default(0),
    maxGdfClassifications: z.number().default(800),
    minOccurrencesPerClassification: z.union([z.literal('auto'), z.number()]).default('auto'),
    generalOutliersQuantile: z.number().default(0),
    classificationOutliersQuantile: z.number().default(0.1),
    minAreaKm2: z.number().default(0.01),
    simplifyEpsilon: z.number().default(0.0005),
    withTopology: z.boolean().default(true),
  }),
  output: z.object({
    featureCollection: featureCollection(
      z.union([polygon(), multiPolygon(), z.null()]),
      z.object({
        key: z.string(),
        ine: z.string(),
        healthUnitCnes: z.string(),
        name: z.string(),
        kind: coverageAreaKind,
        latitude: latitude(),
        longitude: longitude(),
      }),
    ),
  }),
})

export default healthTeamSmartMappingDefinition
